// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"feb0941e","452":"9baf4233"}[chunkId] + ".1787105563750.chunk.css";
};